import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import {Subscription} from 'rxjs';
import {Product} from '../../../generic/classes/product';
import {ActiveOrderService} from '../../../generic/service/active.order.service';
import {ApplicationService} from '../../../generic/service/application.service';
import {ProductService} from '../../../generic/service/product.service';
import {ShoppingCartService} from '../../../generic/service/shoppingcart.service';
import {UserService} from '../../../generic/service/user.service';
import {DecimalPipe} from '@angular/common';
import {BuyUnitComponent} from './buy.unit.component';
import {RenderCheckoutIconComponent} from '../../../generic/component/cart/render.checkout.icon';

@Component({
	selector: 'buy-options',
	templateUrl: 'buy.options.component.html',
	styleUrls: ['./buy.component.scss'],
	standalone: true,
	imports: [
		RenderCheckoutIconComponent,
		BuyUnitComponent,
		DecimalPipe
	],
})
export class BuyOptionsComponent implements OnInit, OnDestroy {
	private shoppingCartService = inject(ShoppingCartService);
	private activeOrderService = inject(ActiveOrderService);
	private userService = inject(UserService);
	productService = inject(ProductService);
	applicationService = inject(ApplicationService);

	@Input() public product: Product;
	@Input() public disabled: boolean;
	public buyAllPrice: number;
	public userCurrency: string;
	public itemsInOrder: number = 0;
	public buttonShowPressed: boolean = false;
	public showConfirmation: boolean = false;
	private shoppingcartSubscription: Subscription;
	private disableBuyAll: boolean = false;

	constructor() {
		this.shoppingcartSubscription = this.shoppingCartService
			.getShoppingCartObservable()
			.subscribe(() => this.updateItemsInOrder());
	}

	ngOnDestroy(): void {
		this.shoppingcartSubscription.unsubscribe();
	}

	isFastCheckout(): boolean {
		return this.userService.isUseFastCheckout();
	}

	ngOnInit() {
		this.buyAllPrice = this.product.buyAllPrice;
		this.userCurrency = this.applicationService.getUserCurrency();
		this.updateItemsInOrder();
	}

	buyAll() {
		this.disableBuyAll = true;
		if (this.product.availableQuantity > 0) {
			// Don't show the spinner if the user is first to select an order in the popup.
			if (this.activeOrderService.hasSelectedOrder()) {
				this.buttonShowPressed = true;
			}

			const productOrderDone = this.shoppingCartService.orderProduct(
				this.product,
				null,
				true
			);

			// Can be null if the user had first to select an (new) active order.
			if (productOrderDone == null) {
				return;
			}

			productOrderDone.subscribe(
				() => {
					if (this.buttonShowPressed) {
						this.showConfirmation = true;
						this.productService.triggerProductAddedToCartEvent(this.product);

						setTimeout(() => {
							this.showConfirmation = false;
							this.buttonShowPressed = false;
							this.disableBuyAll = false;
						}, 2000);
					}
				},
				() => {
					this.buttonShowPressed = false;
					this.disableBuyAll = false;
				},
			);
		}
	}

	disableBuyAllButton(): boolean {
		return this.disableBuyAll || !this.isBuyAllEnabled();
	}

	isBuyAllEnabled() {
		return this.getAvailableQuantity() > 0;
	}

	/**
	 * Take the quantity already ordered into account
	 *
	 * @returns {number}
	 */
	public getAvailableQuantity(): number {
		const available = this.product.availableQuantity - this.itemsInOrder;

		return available < 0 ? 0 : available;
	}

	private updateItemsInOrder() {
		this.itemsInOrder = this.shoppingCartService.getNumberOfItemsInOrderForProduct(this.product);
	}
}
